/**
 * Created by shinan.chen on 2021/12/25.
 */
import {getCommon, postCommon } from '../tools';
import * as config from '../config';

export interface IStore{
    id:number,
    name:string,
    owner:string,
    address:string,
    openTime:Date,
    studentCount:number,
}

export const listStores = () =>
    getCommon({
        url: `${config.SERVICE_URL}/store/list_all`,
    });

export const createStore = (data:IStore) =>
    postCommon({
        url: `${config.SERVICE_URL}/store/create`,
        data
    });

export const updateStore = (data:IStore) =>
    postCommon({
        url: `${config.SERVICE_URL}/store/update`,
        data
    });

export const deleteStore = (id:number) =>
    postCommon({
        url: `${config.SERVICE_URL}/store/delete?id=${id}`
    });

export const pageStores = (pageNum:number,pageSize:number) =>
    getCommon({
        url: `${config.SERVICE_URL}/store/page?pageNum=${pageNum}&&pageSize=${pageSize}`,
    });